







































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

@Component({})
export default class BulkCuratedUpload extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private currentJobId = this.jobId;
  private file: any = null;
  private fileName = "";
  private jobDetails: any = {};

  private errorMessage = "";
  private errorMessageTop = "";

  mounted() {
    this.getJobDetails();
  }

  @Watch("errorMessage")
  @Watch("errorMessageTop")
  focusErrorAlert() {
    if (this.errorMessage !== "" || this.errorMessageTop !== "") {
      (this.$refs.uploadHeader as any).scrollIntoView();
    }
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.specialErrors, errorCode)) {
      this.removeUploadedFile();
      this.$store.commit("recordError", "");
      this.errorMessage = errorsUtil.specialErrors[errorCode];
    } else if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  private previous() {
    (this.$parent as any).previousStep();
  }

  getJobDetails() {
    this.$store.commit("startLoading");
    this.$api
      .get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}`
      )
      .then((response) => {
        const jobDetails = response.data;
        this.jobDetails = jobDetails;
        this.fileName = jobDetails.metadata.curatedFileName;
        this.$store.commit("stopLoading");
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private fileChosen(e) {
    this.file = e.detail.files[0];
    this.fileName = this.file.name;
  }

  private findFileType(file: any) {
    if (file && file.type) {
      if (file.type === "text/tab-separated-values") {
        return "tsv";
      }
      if (file.type === "text/csv") {
        return "csv";
      }
    }
    return file && file.name && file.name.slice(-4).toLowerCase() === ".tsv"
      ? "tsv"
      : "csv";
  }

  private removeUploadedFile() {
    this.file = null;
    this.fileName = "";
  }

  private isSaveDisabled() {
    return !this.fileName || this.fileName === "" || this.$store.state.loading;
  }

  async downloadInputFile() {
    try {
      this.$store.commit("startLoading");
      const downloadResponse = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/inputFile`,
        {
          params: {},
          responseType: "arraybuffer",
          headers: {
            Accept: "application/octet-stream",
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "input.csv");
      document.body.appendChild(link);
      link.click();
      this.$store.commit("stopLoading");
    } catch (e) {
      this.$store.commit("stopLoading");
      this.displayError(e);
    }
  }

  async nextStep() {
    this.$store.commit("startLoading");
    try {
      if (this.file) {
        const fileType = this.findFileType(this.file);
        const formData = new FormData();
        formData.append("file", this.file);
        const uploadResponse = await this.$api.put(
          `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}/uploadCurated`,
          formData,
          {
            params: { fileType },
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        this.$store.commit("stopLoading");
      }
      this.$emit("step-done");
    } catch (error) {
      this.$store.commit("stopLoading");
      this.displayError(error);
    }
  }

  async skip() {
    this.$store.commit("startLoading");
    try {
      const metadataUpdated = Object.assign(this.jobDetails.metadata, {
        curatedFileName: "",
      });
      const markStepCompletion = await this.$api.put(
        `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}`,
        {
          jobName: this.jobDetails.metadata.jobName,
          tags: this.jobDetails.tags,
          metadata: metadataUpdated,
        }
      );
      this.$store.commit("stopLoading");
      this.$emit("step-done");
    } catch (error) {
      this.$store.commit("stopLoading");
      this.displayError(error);
    }
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }
}
